var _defs, _path, _g, _path2, _g2, _path3, _g3, _g4, _path4, _g5, _path5, _g6, _polygon, _polygon2, _polygon3, _g7, _polygon4, _polygon5, _polygon6, _g8, _g9, _ellipse, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse2, _path16, _path17, _polygon7, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _polygon8, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _circle, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g10, _ellipse3, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _circle2, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _line, _line2, _line3, _line4, _path108, _path109, _line5, _line6, _line7, _line8, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlluWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "4bb361e0-c198-4236-8a2c-16fdc74357b9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1077.87 757.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "3a04da5e-6bbd-4e40-9ddd-c72d719fea9d",
    x1: 2507.03,
    y1: 696.19,
    x2: 2507.03,
    y2: 413.55,
    gradientTransform: "matrix(-1, 0, 0, 1, 2766, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "product tour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M724.89,163.21c-46.25,32.38-106.24,30.29-158.81,13.44S465.22,129.8,414,108.48A494.21,494.21,0,0,0,280.38,73.65c-65.28-7.47-138.18,1.63-183.66,54-50.65,58.29-46.76,163.45,8,217,27.87,27.22,64.36,40.58,96.18,61.83S262.2,463,259.49,504c-2.51,38-31.68,67.12-61.87,85.41-23.33,14.13-52.06,29.56-54.87,58.83-2.72,28.32,21.44,50.51,44.51,63.13,75.26,41.18,168,40.78,243-1C457,695.42,481.56,675.58,509.61,664c73.65-30.52,154.81.21,232.8,11.44a465.38,465.38,0,0,0,198-14.41c38.62-11.41,77.39-28.85,104.52-61.34,19.57-23.43,31.76-53.07,43.2-82.36q18.3-46.83,35.19-94.33c6.75-19,13.4-38.38,15.15-58.72,3.16-36.85-10.16-73.28-28.3-104.38C1067.1,186,994.56,134.08,916,120.89S754.33,133.46,693.4,189.83",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.71,174.77l-3.81,221s137.92,0,255.27,38.1l2.28-223.26S667.24,165.62,601.71,174.77Z",
    transform: "translate(-61.06 -71.37)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M598.71,170.77l-3.81,221s137.92,0,255.27,38.1l2.28-223.26S664.24,161.62,598.71,170.77Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#f7f7fd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.47,181.1l3.81,221s-137.92,0-255.26,38.1l-2.29-223.26S466.94,172,532.47,181.1Z",
    transform: "translate(-61.06 -71.37)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M535.47,176.1l3.81,221s-137.92,0-255.26,38.1l-2.29-223.26S469.94,167,535.47,176.1Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#f7f7fd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.52,201.88l2.05,118.51s-74,0-136.9,20.43l-1.23-119.73S438.38,197,473.52,201.88Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M936.74,256.06V474.75s45-5.34,139.45,111.25l8.38-218.69S986.27,261.39,936.74,256.06Z",
    transform: "translate(-61.06 -71.37)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M934.74,253.06V471.75s45-5.34,139.45,111.25l8.38-218.69S984.27,258.39,934.74,253.06Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#f7f7fd"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.39,257.06V475.75S164.43,470.41,70,587L61.57,368.31S159.86,262.39,209.39,257.06Z",
    transform: "translate(-61.06 -71.37)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.39,253.06V471.75S167.43,466.41,73,583L64.57,364.31S162.86,258.39,212.39,253.06Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#f7f7fd"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "574.5 145.37 667.93 162.08 667.93 175.69 574.5 157.75 574.5 145.37",
    fill: "#6c63ff"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "394.5 276.87 301.08 293.58 301.08 307.19 394.5 289.25 394.5 276.87",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "575.74 170.74 746.5 206.01 746.5 219.62 575.74 183.12 575.74 170.74",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "575.74 196.11 746.5 231.37 746.5 244.99 575.74 208.48 575.74 196.11",
    fill: "#fff"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "913.5 252.31 913.5 264.32 950.13 294.08 951.85 283.78 913.5 252.31",
    fill: "#6c63ff"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "913.5 368.31 913.5 380.32 950.13 410.08 951.85 399.78 913.5 368.31",
    fill: "#fff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "914.08 272.91 913.5 284.93 982.75 350.16 981.61 336.43 914.08 272.91",
    fill: "#fff"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "913.5 295.23 913.5 306.67 982.75 373.06 982.75 358.18 913.5 295.23",
    fill: "#fff"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "110.93 254.91 111.5 266.93 42.26 332.16 43.4 318.43 110.93 254.91",
    fill: "#6c63ff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 277.23 111.5 288.67 42.26 355.06 42.26 340.18 111.5 277.23",
    fill: "#6c63ff"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.61,
    cy: 621.88,
    rx: 57,
    ry: 10.26,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.49,636.84s5.49,7.18-2.54,18-14.65,20-12,26.76c0,0,12.11-20.14,22-20.42S141.34,649,130.49,636.84Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.49,636.84a8.63,8.63,0,0,1,1.12,2.25c9.62,11.3,14.75,21.85,5.5,22.12-8.61.24-19,15.65-21.42,19.54.08.29.18.59.29.88,0,0,12.11-20.14,22-20.42S141.34,649,130.49,636.84Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.7,646c0,2.53-.28,4.58-.63,4.58s-.64-2.05-.64-4.58.36-1.34.71-1.34S140.7,643.46,140.7,646Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd037"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.21,649c-2.22,1.21-4.16,1.94-4.33,1.64s1.5-1.54,3.72-2.75,1.34-.33,1.51,0S146.43,647.8,144.21,649Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd037"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.47,636.84S96,644,104,654.87s14.65,20,12,26.76c0,0-12.11-20.14-22-20.42S90.63,649,101.47,636.84Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.47,636.84a9,9,0,0,0-1.12,2.25c-9.62,11.3-14.75,21.85-5.5,22.12,8.62.24,19,15.65,21.42,19.54a7.54,7.54,0,0,1-.29.88s-12.11-20.14-22-20.42S90.63,649,101.47,636.84Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.26,646c0,2.53.28,4.58.63,4.58s.64-2.05.64-4.58-.36-1.34-.71-1.34S91.26,643.46,91.26,646Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd037"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.76,649c2.22,1.21,4.15,1.94,4.32,1.64s-1.5-1.54-3.72-2.75-1.34-.33-1.51,0S85.54,647.8,87.76,649Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd037"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M93,680.69s15.36-.47,20-3.77,23.62-7.23,24.77-1.94,23.08,26.29,5.74,26.43-40.29-2.7-44.91-5.52S93,680.69,93,680.69Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#a8a8a8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.82,699.57c-17.34.14-40.29-2.7-44.91-5.52-3.52-2.14-4.92-9.83-5.39-13.38l-.51,0s1,12.39,5.59,15.2,27.57,5.66,44.91,5.52c5,0,6.74-1.82,6.64-4.46C149.46,698.54,147.55,699.54,143.82,699.57Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600.5,
    cy: 470.71,
    rx: 94,
    ry: 16.1,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M642.6,324.79a13.09,13.09,0,0,0-1,3.07q-.09.4-.18.84c-.6,3.06-1,6.91-1.21,9.15-.1,1.12-.15,1.84-.15,1.84s-21.69-1.45-17.93-5.09a8,8,0,0,0,2-3.6c.11-.39.2-.78.28-1.18a20.28,20.28,0,0,0,.35-2.75c0-.23,0-.46,0-.7a28.36,28.36,0,0,0-.21-4.49s7.05,0,12.37.57C640.5,322.86,643.29,323.57,642.6,324.79Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#d38884"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M605,428c-7.39-.24-1.94-15.63-1.09-17.7s-1.26-7.14-1.26-7.14-2.5-14.66-2.5-15.62a39.15,39.15,0,0,0-.84-5.94,10,10,0,0,1,1-5.82c.85-1.33.72-6.66.72-6.66v-6.9l1.65-2.18,4.21,4,1.17,1.1,2.06,7.72-.73,11.06L609,394.69l2.55,14.9S612.44,428.25,605,428Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#d38884"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "546.28 294.5 539.98 291.88 539.98 290.86 541.62 288.68 545.84 292.66 546.28 294.5",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M604.44,350.11a29.06,29.06,0,0,0-1.75,6.18,27.4,27.4,0,0,1-1.65,5.93l7,2.91Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#4c4981"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M604.44,350.11a29.06,29.06,0,0,0-1.75,6.18,27.4,27.4,0,0,1-1.65,5.93l7,2.91Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.05
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M660.2,503.1l-.58,1.24s-.63,4.11-.63,4.21-1.82,2.84-1.82,2.84l-4.57,1-1.94-.24a27.28,27.28,0,0,0-.52-3.36c-.07-.31-.14-.63-.23-.95a25.68,25.68,0,0,0-3.19-7.24s-3.39-8.36-4.6-9.45-5.82-12.12-5.33-14.78c.26-1.46.05-6.36-.19-10.44-.2-3.33-.42-6.13-.42-6.13L647.69,453l1.34,2.11a0,0,0,0,0,0,0l.8,1.25s0,.24-.05.64v.15a21.34,21.34,0,0,1-1,5s-.86,6.18,0,7.27,3.6,15.66,4.21,22.4c0,.21,0,.42,0,.61.24,3.1,2.16,5.86,4.09,7.88l0,0c.12.14.25.27.38.4A26.38,26.38,0,0,0,660.2,503.1Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#d38884"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M650.66,512.13l1.94.24,4.57-1s1.82-2.75,1.82-2.84.63-4.21.63-4.21l.58-1.24.07-.15a24.29,24.29,0,0,1-3.14-2.59l0,0c-.11-.1-.22-.2-.32-.31s.65,4-2.83,5.79c-1.69.87-3.08,1.54-4.05,2Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M661,503.68l-.65,1.39s-.63,4.11-.63,4.21-1.82,2.84-1.82,2.84l-4.57,1-2.63-.31c0-.53-.09-1.28-.22-2.19-.08-.55-.19-1.16-.34-1.82,1-.45,2.55-1.19,4.54-2.22,3.49-1.79,2.83-5.79,2.83-5.79a27.57,27.57,0,0,0,2.39,2.12C660.38,503.25,660.77,503.52,661,503.68Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ceddf9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M661,503.68l-.65,1.39s-.63,4.11-.63,4.21-1.82,2.84-1.82,2.84l-4.57,1-2.63-.31c0-.53-.09-1.28-.22-2.19a9.11,9.11,0,0,1,1.66.23s6.24,1.33,6.54-3.61c.18-2.8.76-3.9,1.22-4.33C660.38,503.25,660.77,503.52,661,503.68Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M660.54,503.35s-1.55-.34-1.86,4.59-6.54,3.61-6.54,3.61-3.06-.76-3.09.51a11.88,11.88,0,0,0,.82,3.42s.18,2.94.76,3.64.21,3.3.21,3.3.24,1.94,5.06,0c0,0,4.3-.89,7.87-6.24.12-.18-.42-.73,2.7-1.85s12-8.3,11.36-11.81a3,3,0,0,0-2.12-2.52,3.65,3.65,0,0,0-2.79.38,22.09,22.09,0,0,1-2.61,1.2,12.81,12.81,0,0,1-3.72.89,14.31,14.31,0,0,0-2.89.55A6,6,0,0,1,660.54,503.35Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#cc8294"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M625.22,469.41a8.48,8.48,0,0,0-1.76,2c-1.76,2.69-2.82,6.45-4,8.07-1.54,2.1-2,6.18-2,6.18-.41,2.68-6.09,17-7.63,19.54s-3.68,9.45-3.68,9.45c-1.31,1.64-1.23,4.08-1.1,5.24,0,.2,0,.36.06.47s0,.19,0,.19l0,.07-2.1,3.57-6.68-.93-3.45-2.34a11.74,11.74,0,0,0,.75-1.43c1.85-4.12,3.16-11.48,3.16-11.48s1.86-8.4,1.72-10.36a78.49,78.49,0,0,1,.55-8S604.32,473.6,606,471a7.48,7.48,0,0,0,1.26-3.45,2.9,2.9,0,0,0,0-.75l2.26-2.25S628.12,467.1,625.22,469.41Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#d38884"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M605.18,519.85s0,.2,0,.53v.26l-2.1,3.57-6.68-.93-3.45-2.34a11.74,11.74,0,0,0,.75-1.43c1.68-.48,5.52.88,5.52.88s4.15.79,5.9-.48C605.12,519.9,605.14,519.87,605.18,519.85Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M603.55,529.38,596.77,531l-6.22-4.6.32-2.59a4.47,4.47,0,0,0,1.14-1,4.1,4.1,0,0,0,.9-1.86c.36-1.91,6.27.18,6.27.18s4.32.82,6-.55a10.54,10.54,0,0,0,.32,3.74,2.79,2.79,0,0,0,1,1.49C608.23,527,603.55,529.38,603.55,529.38Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ceddf9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M603.55,529.38,596.77,531l-6.22-4.6.32-2.59a4.47,4.47,0,0,0,1.14-1c.45,0,.94,0,1.36,0,1,.1,3.5,4.55,3.5,4.55,6.14.41,8-1.6,8.63-3.08a2.79,2.79,0,0,0,1,1.49C608.23,527,603.55,529.38,603.55,529.38Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M596.87,528.11s-2.46-4.45-3.5-4.54a23.54,23.54,0,0,0-2.64,0s-2.72,6.45-3.72,7-2.46,3.64-2.46,3.64,7.2,7,14.16,5.63a14.43,14.43,0,0,1,6.38,1.59c3.22,1.68,16.67.41,18.31-2.54,1.22-2.22,1.71-3.83.63-5a2.92,2.92,0,0,0-2.53-.86c-1.69.23-5.49.19-8.82-3.9,0,0-6.14-5.62-6.64-5.63S606.45,528.75,596.87,528.11Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#cc8294"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M649.84,457.09l-.05.06c-.42.46-3.38,3.71-4.28,3.94a42.75,42.75,0,0,0-4.36,1.93s-1.82,2.43-3.27,2.55a5.71,5.71,0,0,0-1.28.34c-.2-3.33-.42-6.13-.42-6.13L647.69,453l1.34,2.11a0,0,0,0,0,0,0c.3.85.64,1.64.75,1.89Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M608,410.3s-4.48,5.84,0,13.59a45.27,45.27,0,0,0,9.21,11.63l15.26,31.62s4-2.18,5.46-2.3,3.27-2.54,3.27-2.54a42.36,42.36,0,0,1,4.36-1.94c1-.24,4.33-4,4.33-4s-1.67-3.63-1.3-4.6-1.09-3.4-1.09-3.4a20,20,0,0,1-1-3.75c0-1-1.58-3.27-1.58-3.27s-1.57-2.43-1.57-3.76S641,431,641,431l-.61-23Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ceddf9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M649.84,456.36s-3.36,3.75-4.33,4a42.36,42.36,0,0,0-4.36,1.94s-1.82,2.42-3.27,2.54a11.6,11.6,0,0,0-3,1.07c-1.3.59-2.47,1.23-2.47,1.23l-15.27-31.62a33.07,33.07,0,0,1-3.71-3.8,52.47,52.47,0,0,1-5.5-7.83,13.11,13.11,0,0,1-1.74-9.43,10.85,10.85,0,0,1,1.74-4.15l10.86-.77L640.42,408l.18,6.81L641,431s.35.81.79,1.88a20.55,20.55,0,0,1,1.51,4.66c0,1.34,1.57,3.76,1.57,3.76s1.58,2.3,1.58,3.27a20.28,20.28,0,0,0,1,3.76s1.46,2.42,1.1,3.38S649.84,456.36,649.84,456.36Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.05
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M625.22,469.41a8.48,8.48,0,0,0-1.76,2c-6.59.48-14.25-3-16.24-3.92a2.9,2.9,0,0,0,0-.75l2.26-2.25S628.12,467.1,625.22,469.41Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M644.66,417.47s-1,3.39-1.33,4.84-1.09,8.61-1.09,8.61l-.42,2-6.92,33-1.51,7.17c-2.66,1.46-9.32-2.43-9.32-2.43-7.76.86-17.33-4.11-17.33-4.11s1.57-5.09,1.21-7.63,2.18-4.61,2.18-4.61c-.6-2.3,1.57-12.36,1.57-12.36s.49-3.75,2.31-4.72-.24-2.42-.73-3.28a3.71,3.71,0,0,1,.17-2.22,16.44,16.44,0,0,1,.56-1.65c-4.62-4.62-5.33-11.84-5.34-15.85a25.62,25.62,0,0,1,.13-2.93l10-1.75,21.85-3.82,2.23,6.86v0l.56,1.72Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ceddf9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M642.6,324.79a13.09,13.09,0,0,0-1,3.07q-.09.4-.18.84c-2.11,1.37-3.41,1.38-6.11,1.38-.93,0-1.45-1.78-2.33-2,0,0-1.32-4.76-1.69-.75-2.54-.52-4.73,1.46-6.53-.27l0,0c0-.23,0-.46,0-.7a28.36,28.36,0,0,0-.21-4.49s7.05,0,12.37.57C640.5,322.86,643.29,323.57,642.6,324.79Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M647.6,316.63a13.52,13.52,0,0,1-16.21,13.23h0A13.5,13.5,0,1,1,645.87,310,13.26,13.26,0,0,1,647.6,316.63Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#d38884"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M640.21,337.85c-.1,1.12-.15,1.84-.15,1.84s-21.69-1.45-17.93-5.09a8,8,0,0,0,2-3.6l9.41,1.54s2.66,2.06,4.72,4A8.55,8.55,0,0,0,640.21,337.85Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M643.45,415a7,7,0,0,1-2.85-.21,5.78,5.78,0,0,1-1.15-.51c-1.82-1.09-7.87.25-7.87.25s-16.48,1.09-17.21,0c-.41-.63-3.32-.54-5.7-.35-1,.08-1.85.18-2.46.24a10.85,10.85,0,0,1,1.74-4.15l10.86-.77,21.85-3.82,2.23,6.86v0A24.63,24.63,0,0,0,643.45,415Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M633.51,333.27l-11.82-1.94a3.52,3.52,0,0,1-2.23,1.94c-1.57.36-8.6,4-11.75,8.36L604.56,346s-2.55,3.15-1.7,5.69,1.82,11.15,1.82,11.15l1.21,9.57s2.3,6.91,1.58,9.94.36,15.75.36,15.75l-2.42,15.75s8.23-1.09,9,0,17.21,0,17.21,0,6-1.34,7.87-.25a6.58,6.58,0,0,0,4,.73s-1.45-5-.61-7.75.61-7.88.61-7.88,1.21-7.39.6-8.72,1.34-6.18,1.34-6.18l6.42-33.8s-.78-6.06-4.21-8.12-7.3-2.67-9.36-4.6S633.51,333.27,633.51,333.27Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#4c4981"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M639,366.59v4l3.73,10.06,1.35,9.33s2.43,6.66,2.43,9,5.93,13.45,5.93,13.45,1.62,3.76.81,4.48-7.83,16.72,1,16.24,6.06-17.2,6.06-17.2l-1.21-7.27s-1.7-18.18-1.7-19.51c0,0-2.18-7.75-2.42-9.45s-1.82-10.3-1.82-10.3l-1.33-5.57Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#d38884"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "573.69 307.82 560.52 315.36 556.43 321.54 561.88 316 573.69 307.82",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M630.76,393.63s-6,3.91-8.82,3.91-9.36,6.72-9.36,6.72,9.27-6,10-5.81S630.76,393.63,630.76,393.63Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M615.4,395.72s-5.63,5.09-4.18,5.64,9-5.64,9-5.64Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M640.3,377.55s-4.36,5.91-3.18,5.82,4.54-3.46,4.54-3.46Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M640.93,383.37s-4.72,5.36-4.54,6.72S640.93,383.37,640.93,383.37Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M642.12,386.05s-3.18,5.68-1.82,6.86S642.12,386.05,642.12,386.05Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M638,371.46s-2.37,4-.64,4.27,1.9,0,1.9,0Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M638.66,356.83a41.76,41.76,0,0,1-2.42,7.13,33.06,33.06,0,0,1-.94-3.57A24.36,24.36,0,0,1,638.66,356.83Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M645.87,310a5.88,5.88,0,0,1-.91,1.41,10.44,10.44,0,0,0-1.64,1.88,10.09,10.09,0,0,0-.59,3.21c-.18,1.08-.86,2.28-2,2.31a4.06,4.06,0,0,1-1.6-.48,1.63,1.63,0,0,0-1.59.05,1.78,1.78,0,0,0-.51,1.2,15.87,15.87,0,0,0-.16,2.84c0,.38,0,.75.06,1.13a6.35,6.35,0,0,1-.21,3.6,4.36,4.36,0,0,1-2.24,1.8,13.85,13.85,0,0,1-3.14.88h0a34.52,34.52,0,0,1-6.19.2,1.53,1.53,0,0,1-.56-.09.79.79,0,0,1-.24-.15,18.93,18.93,0,0,0,.37-3.45A13.5,13.5,0,1,1,645.87,310Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M640.23,298.57c-1.24-.13-2.41.53-3.63.8-2.51.55-5.08-.59-7.66-.58a14.22,14.22,0,0,0-6.3,1.88,15.21,15.21,0,0,0-4.2,2.94,6.85,6.85,0,0,0-2,4.62,7.57,7.57,0,0,1-.09,3,8.45,8.45,0,0,1-.92,1.4,4.16,4.16,0,0,0-.43,3.47,11.51,11.51,0,0,0,2.07,3.1c1.66,2.13,2.7,4.68,4.19,6.94a21.6,21.6,0,0,0,2.18,2.77,1.54,1.54,0,0,0,.47.37,1.44,1.44,0,0,0,.55.08c3.16.09,6.43.16,9.34-1.08a4.27,4.27,0,0,0,2.24-1.8,6.35,6.35,0,0,0,.22-3.6,16.49,16.49,0,0,1,.09-4,1.76,1.76,0,0,1,.51-1.19,1.6,1.6,0,0,1,1.6-.05,4.36,4.36,0,0,0,1.59.48c1.09,0,1.78-1.24,2-2.32a5.44,5.44,0,0,1,2.23-5.09,7.7,7.7,0,0,0,1.37-6.83C644.93,301.63,642.73,298.82,640.23,298.57Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#1e1637"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M653.2,356a15.74,15.74,0,0,0,0,5c-.12,1.34,0,8.73,0,8.73-4-1.22-14.17,1.21-14.17,1.21l-1.21-3.63a9,9,0,0,1-1.52-3,33.25,33.25,0,0,1-.94-3.58,74.25,74.25,0,0,1-1.19-7.61c-.51-3.85,5.22-8,9.56-10.3s8.14,7.51,8.14,7.51S653.68,354.1,653.2,356Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M653.2,355.31a15.79,15.79,0,0,0,0,5c-.12,1.33,0,8.72,0,8.72-4-1.21-14.17,1.21-14.17,1.21l-1.21-3.63a8.9,8.9,0,0,1-1.52-3,33.06,33.06,0,0,1-.94-3.57,74.69,74.69,0,0,1-1.19-7.61c-.51-3.86,5.22-8,9.56-10.31s8.14,7.51,8.14,7.51S653.68,353.37,653.2,355.31Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#4c4981"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M645.51,303.88a8,8,0,0,0-.89-1.95c.06.17.12.33.17.5a7.7,7.7,0,0,1-1.37,6.83,5.44,5.44,0,0,0-2.23,5.09c-.17,1.08-.86,2.27-2,2.31a4.06,4.06,0,0,1-1.6-.48,1.63,1.63,0,0,0-1.59.05,1.78,1.78,0,0,0-.51,1.2,16.4,16.4,0,0,0-.09,4c.11,1.22.35,2.53-.22,3.61a4.45,4.45,0,0,1-2.24,1.8c-2.91,1.24-6.18,1.17-9.34,1.08a1.45,1.45,0,0,1-.55-.09,1.29,1.29,0,0,1-.47-.37,19.4,19.4,0,0,1-2.18-2.77c-1.49-2.26-2.53-4.8-4.19-6.94-.45-.58-1-1.15-1.37-1.76l0,.12a11.07,11.07,0,0,0,2.07,3.1c1.65,2.13,2.7,4.68,4.18,6.94a20.83,20.83,0,0,0,2.19,2.77,1.5,1.5,0,0,0,.46.37,1.47,1.47,0,0,0,.55.08c3.16.09,6.44.16,9.34-1.08a4.27,4.27,0,0,0,2.24-1.8,6.35,6.35,0,0,0,.22-3.6,17.58,17.58,0,0,1,.09-4,1.85,1.85,0,0,1,.51-1.19,1.6,1.6,0,0,1,1.6-.05,4.36,4.36,0,0,0,1.59.48c1.1,0,1.78-1.24,2-2.32a9.82,9.82,0,0,1,.59-3.21,10.06,10.06,0,0,1,1.64-1.88A7.72,7.72,0,0,0,645.51,303.88Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M743,306.51l-8.64,18.36s-1.27,3.45-2.09,4.09-4.45,11.54-4.45,11.54l-9.27,14.28h0l-.63,1-3.63-1-2.55-9.52.15-2.76,0-.35s5.72-6,7-6.45c0,0,1,.12,2.9-4.53s3.64-5.65,3.64-5.65l1-3.36,10.73-17.09s9-12.89,11.45-7.17S743,306.51,743,306.51Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd2c6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M707.12,436.93a2.07,2.07,0,0,1-.29.88c-1,1.46-6.63,31.17-6.63,31.17.45,2-.82,6-1.64,7.82s-2.64,11.26-2.64,11.26-.45,20.36-1.62,23.54.37,10,.37,10c-.11,3.13,1.77,6.45,2.89,8.13l.22.32c.36.52.6.82.6.82a4.84,4.84,0,0,0,1.27,1.57l.26.2a14.68,14.68,0,0,0,5.09,2.15l.18,0c.72.16,1.2.23,1.2.23l.45,2.46-4.81,1-9.18.63s-10.82.83-8.36-4a7.65,7.65,0,0,0,.44-1h0a7.61,7.61,0,0,0,.25-.72c1.48-4.63.48-10.26.48-10.26l-2.09-16.44c-3.45-15.27,2.71-32.26,2.71-32.26s-.53-1.36.65-4.81,0-11,0-11-.63-9.72-1.45-14.53a29.46,29.46,0,0,1-.33-6.13,30.51,30.51,0,0,1,.33-3.58l20.71-2.75S707.37,435,707.12,436.93Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd2c6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M706.83,537.5l-4.81,1-9.18.63s-10.82.83-8.36-4a7.65,7.65,0,0,0,.44-1h0a7.61,7.61,0,0,0,.25-.72,17,17,0,0,1,5.48,1.1c3.08,1.19,5.4-1.91,5.4-1.91l1.5-2.86.22-.41c.36.52.6.82.6.82a5,5,0,0,0,1.53,1.77l-.26.53-1.45,3.06s1.86.19,4.4.6a2,2,0,0,0,2.4-1.31l.18,0c.72.16,1.2.23,1.2.23Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M711.28,539.76c-.36,1.64-10.49,2.14-10.49,2.14s-5.64-.54-7.22.77-6.23,1-6.41,1-2.63-.09-3.59-4.49,1.25-5,1.35-5.07h0a16.59,16.59,0,0,1,5.73,1.11c3.08,1.19,5.4-1.91,5.4-1.91l1.72-3.27c.36.52.6.82.6.82a5,5,0,0,0,1.53,1.77l-1.71,3.59s1.86.19,4.4.59a2.11,2.11,0,0,0,2.58-2,2.41,2.41,0,0,0,0-.27s1.58.46,3.54,1A3.65,3.65,0,0,1,711.28,539.76Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#626696"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M730.37,458.59c-.24,1.45-.49,5.21-.49,5.21.85,3.15-1.33,10.63-1.33,10.63l-1.09,4.27c.48,5.45-3,18.78-3,18.78s-2.33,12.36-3.54,17.69a14.63,14.63,0,0,0,.63,8.91l.09.22c0,.1.05.2.07.3a3.09,3.09,0,0,0,.14.43,6.39,6.39,0,0,0,1.19,2,5.89,5.89,0,0,0,.65.67l0,0a13.21,13.21,0,0,0,3.86,2.38h0l.61.24a18.85,18.85,0,0,0,1.93.6h0l.22,0-.49,2.86-6.42-1.65-8.6-2.79L710.63,527s0-.23.13-.67a.22.22,0,0,0,0-.08c0-.19.08-.41.13-.67.66-3.75,2.3-14.24,1.48-22-1-9.57,3-22.78,3.93-25.92a15.67,15.67,0,0,0,.73-5.58c-1.58-2.3-1.94-11.51-1.94-11.51s-2.91-5.94-5.31-12.24a31.27,31.27,0,0,1-1.73-6.37,21.59,21.59,0,0,1-.35-4.65s19.51-17.81,21.65-.57c.07.59.14,1.14.21,1.69C731.46,454.28,730.6,457.18,730.37,458.59Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd2c6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M730.37,531l-.49,2.86-6.42-1.65-8.6-2.79L710.63,527s0-.23.13-.67a.22.22,0,0,0,0-.08c0-.19.08-.41.13-.67l.6,0h0a7.9,7.9,0,0,1,3.6.49c1.4.52,3.24,1.12,3.61.87a4.56,4.56,0,0,1,2.06-.36l.89-2,.14-.3a6.28,6.28,0,0,0,1.19,2,7.71,7.71,0,0,0,.69.71l0,.69-.05,1a12.52,12.52,0,0,0,3.09,1.42,1.78,1.78,0,0,0,.86,0h0l.61.24a18.85,18.85,0,0,0,1.93.6h0Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M727.15,537.13c-1.79-.51-6.11-1.34-6.81-.7s-6.69,0-6.69,0a3.64,3.64,0,0,1-3.09-1.81c-1.25-1.94-.24-8.21-.24-8.21l.44,0,.74-.08h0a8,8,0,0,1,3.6.48c1.4.53,3.24,1.13,3.61.88a4.47,4.47,0,0,1,2.06-.37l1-2.25a6.39,6.39,0,0,0,1.19,2,6.52,6.52,0,0,0,.69.7l-.09,1.67a12.79,12.79,0,0,0,3.09,1.43,1.25,1.25,0,0,0,1.48-.47,1.19,1.19,0,0,0,.11-.25h0a11.06,11.06,0,0,0,2.54.84h0a4.64,4.64,0,0,1,5,3.56C736.73,537.34,728.94,537.64,727.15,537.13Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#626696"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M707.12,436.93l-1.11.34a15.5,15.5,0,0,1-2.67.56c-5.74.81-15.19.32-18.19.13a30.51,30.51,0,0,1,.33-3.58l20.71-2.75S707.37,435,707.12,436.93Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M725.19,431.9s-7.6,1.18-13.79,2.53c-2.06.45-4,.93-5.39,1.38a16.43,16.43,0,0,1-2.67.57c-6.89,1-19.13.07-19.13.07-3.36-10.9,4.08-24.63,4.08-24.63-.17-1.09,1.55-4.44,1.55-4.44l0-.11,1.06-3.89h28.25l.35,1.67.72,3.4,4.44,21.07Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#626696"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M729.57,438.51l-.17.07-3.31,1.47c-3.58,1.65-14.29,2-18,2a21.59,21.59,0,0,1-.35-4.65s19.51-17.81,21.65-.57C729.43,437.41,729.5,438,729.57,438.51Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M730.09,436.82l-.69.31-3.31,1.47c-3.64,1.68-14.7,2-18.24,2h-.93c-1.63-.05-3.27-1.58-3.27-2,0-.22-.17-1.3-.31-2.22-.13-.74-.23-1.38-.23-1.38a87.45,87.45,0,0,1-11-5.69c-2.77-1.89-2.07-15.32-1.54-22.07.19-2.33.36-3.86.36-3.86l28.6,1.67,4,.23,2.29.51.61.13s1.65,12,2.46,13,.28,4.36.18,6.28a11.42,11.42,0,0,1-.27,2.45s1.18,3.36.91,5.24A10.47,10.47,0,0,0,730.09,436.82Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#626696"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 638.41,
    cy: 254.14,
    r: 11.72,
    fill: "#ffd2c6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M693.75,330.39s.81,11.1-1.46,13.65a103.38,103.38,0,0,1-8.18,7.36l1.82,7.54,10.27,1.18,12-12.81L705.47,344s-2.09-7.09-.37-10.63S693.75,330.39,693.75,330.39Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd2c6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M718.55,354.78h0l-.63,1-3.63-1-2.55-9.52.15-2.76.75-1.08s4,.09,3.83,3.73C716.3,348.33,718.12,353.57,718.55,354.78Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M726.45,407.38s-2.89.64-6.2,1.07-7.13.66-8.7-.26c-2.63-1.56-16.88-1.11-21-.95l-.7,0,1.06-3.89h28.25l.35,1.67,4,.23,2.29.51C726.22,406.74,726.45,407.38,726.45,407.38Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M711.92,342.13s4,.09,3.82,3.73,2.18,9.9,2.18,9.9l-.91,2.09s-1.27,5.09-.27,6.36,4.63,1.27,2.54,11.72c0,0-.45,7.82.64,10.36s1.09,8.63,2.72,11.18a60.33,60.33,0,0,1,3.82,8.45s-11.81,2.63-14.9.82-22.08-.91-22.08-.91.09-3.18,0-3.55a2.94,2.94,0,0,1,.45-2.31c.64-.87,1.64-2.32,1.09-3.59s1.36-3.15.36-5.12-2.21-2.36-2-3.44a4.63,4.63,0,0,0-1.12-3.44c-.72-.91-5.63-10.51-5.63-10.51l-.82-4.48s-6.32-4.63-6.2-6.81,2.39-5.21,2.39-5.21l6.08-6s3.37,3.63,6.64,2.36,10.3-7.36,10.3-7.36,2.51-1.36,2.69-2.36,1.73-.09,1.73-.09,2.27-1.25,2.72-.81a8,8,0,0,0,2.46.81Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffcde5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M677.57,361.06l-1.93,1.52a25.55,25.55,0,0,0-2.43,9.9,130.57,130.57,0,0,1-2.45,15.34l-3.82,6.83s-6.27,13.17-7.09,16.67-4.54,9.41-4.54,9.41-12.63,11.35-3.82,13.4,9.09-9,9.09-9,2-2.27,2.39-3.82S674.48,400,674.48,400s3.91-5.32,3.09-8.14c0,0,5.09-12,5.09-15a52.71,52.71,0,0,0-.82-7.48l.82-6.27Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd2c6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M703.74,386.11s-8.9,4.66-10.63,4.91,7.54-1,7.54-1Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M711,389.74s-11.81,4-17,3.28C694,393,706.92,395.47,711,389.74Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M711.74,391.05s-10.64,6.69-16.9,5.6c0,0,14.63,2.91,16.9,1.36l-6.54-1.81S712.46,392.35,711.74,391.05Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M699.49,304.88a11.06,11.06,0,0,0-9,1.69c-1.82,1.43-3,3.62-5.08,4.69a27.21,27.21,0,0,1-3.32,1.17,9.59,9.59,0,0,0-5.85,10.32c.32,1.8,1.16,3.46,1.58,5.24.74,3.17.08,6.49-.72,9.65a101.73,101.73,0,0,1-10.1,25.05,2.66,2.66,0,0,0-.5,1.68,2.47,2.47,0,0,0,.62,1.07c4.2,4.85,11,6.52,17.45,6.74a13.48,13.48,0,0,0,6.92-1.15,10.48,10.48,0,0,0,3.37-3.09A16.42,16.42,0,0,0,698,357.38c-.17-3.05-1.19-6.13-.42-9.08a2.32,2.32,0,0,1,.54-1.11c.69-.71,1.84-.52,2.82-.64,2.67-.31,4.39-3.12,4.71-5.79s-.35-5.35-.37-8a16.86,16.86,0,0,1,3.17-9.89c.89-1.22,2-2.42,2.32-3.95.38-1.92-.73-3.33-1.69-4.84-1.49-2.36-2.22-5.11-4.49-6.91A12.11,12.11,0,0,0,699.49,304.88Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M698.76,304.15a11,11,0,0,0-8.94,1.69c-1.82,1.44-3,3.63-5.09,4.7a29,29,0,0,1-3.32,1.16A9.59,9.59,0,0,0,675.56,322c.32,1.8,1.16,3.46,1.58,5.24.74,3.17.09,6.49-.72,9.65a101.54,101.54,0,0,1-10.09,25,2.56,2.56,0,0,0-.5,1.68,2.31,2.31,0,0,0,.61,1.07c4.2,4.86,11,6.52,17.45,6.74a13.55,13.55,0,0,0,6.92-1.14,10.62,10.62,0,0,0,3.37-3.1,16.43,16.43,0,0,0,3.13-10.56c-.18-3-1.2-6.13-.43-9.08a2.51,2.51,0,0,1,.54-1.11c.7-.71,1.84-.52,2.83-.63,2.66-.31,4.38-3.13,4.7-5.79s-.35-5.35-.36-8a16.76,16.76,0,0,1,3.17-9.88c.88-1.23,2-2.43,2.32-4,.37-1.92-.74-3.32-1.7-4.84-1.49-2.35-2.22-5.11-4.49-6.91A12.11,12.11,0,0,0,698.76,304.15Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#985c7e"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M694.84,417.76s2.33,10.91,6.21,13.87Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.25,324.46c-.12-.42-.26-.85-.41-1.27C676,323.62,676.1,324,676.25,324.46Z",
    transform: "translate(-61.06 -71.37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.4,315a4,4,0,0,1,0,1c-.3,1.53-1.43,2.73-2.32,3.95a16.89,16.89,0,0,0-3.17,9.89c0,2.69.68,5.37.36,8s-2,5.48-4.7,5.78c-1,.12-2.13-.07-2.82.64a2.53,2.53,0,0,0-.55,1.11c-.77,2.95.26,6,.43,9.08A16.43,16.43,0,0,1,693.45,365a10.37,10.37,0,0,1-3.37,3.09,13.43,13.43,0,0,1-6.91,1.15c-6.31-.21-13-1.84-17.24-6.51a1.66,1.66,0,0,0-.1.88,2.31,2.31,0,0,0,.61,1.07c4.2,4.86,11,6.52,17.45,6.74a13.55,13.55,0,0,0,6.92-1.14,10.62,10.62,0,0,0,3.37-3.1,16.43,16.43,0,0,0,3.13-10.56c-.18-3-1.2-6.13-.43-9.08a2.51,2.51,0,0,1,.54-1.11c.7-.71,1.84-.52,2.83-.63,2.66-.31,4.38-3.13,4.7-5.79s-.35-5.35-.36-8a16.76,16.76,0,0,1,3.17-9.88c.88-1.23,2-2.43,2.32-4A4.49,4.49,0,0,0,709.4,315Z",
    transform: "translate(-61.06 -71.37)"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.18,
    cy: 500.1,
    rx: 21.16,
    ry: 2.14,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M197.64,536.09s-27.6,14.26-13.34,31a5.3,5.3,0,0,0,5.22,3.39s-.78-1.41,2.19-2.54a14.43,14.43,0,0,0,3-1.58,7,7,0,0,0,2.67-3.57h0s5.65-7.55,1.27-21.52c0,0,.57-4,.07-4.59l-3.35,4.59s3.47,2.33,3.87,5.75c0,0-3.61-5.74-4.4-5.08-.16.13-1.66,2.51-1.66,2.51s6,4.08,6.45,9.37c0,0-3.38-7.41-7-8.47l-2.06,3.73s6.56,4,7.3,10c0,0-3.81-7.62-7.7-9.15l-1.53,3.94s6.32,4,6.9,9c0,0-5.29-8.36-7.19-8.09,0,0-1.19,3.7-1,4.84,0,0,4.48,3,4.56,5.93,0,0-4.13-5.22-4.77-4.87,0,0-.26,5.24,1,8a15.9,15.9,0,0,1-1.83-8,8.69,8.69,0,0,0-2.64,4.26s-1.19-2.89,2.72-5.53c0,0,.37-4.08.82-4.58,0,0-4.23,2.06-6,4.6,0,0,.66-3.78,6.4-5.66l1.46-4s-5.74,2.43-7.52,4.57c0,0,1.28-3.75,8-5.55l2-3.68s-5.1,1.72-7.59,3.68c0,0,1.93-3.23,8.2-4.71l1.62-2.31s-3.71,1.33-4.74,1.8-1.24.24-1.24.24a13.28,13.28,0,0,1,6.64-3S197.89,536.34,197.64,536.09Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M224.83,561.47c2.89,1.71,7.41,2.82,13.1-.85l-.06,8.11c.41,5.57,7.28,25.83,7.28,25.83L250,611.24a130.43,130.43,0,0,1,5.34,36.27,34.66,34.66,0,0,0,1.55,11.42c2.58,7-1,16-2.58,19.33-2.88,1-5.85,1.75-8,2.25a5.48,5.48,0,0,0-.72.22l0-.05s-7.28,2.89-10.52,2.49c-2.41-.3-3.92,2.71-2,4.92a14.67,14.67,0,0,1-4.85.64c-3.24-.4-4.85,5.17,1.21,6.76s40.46,0,40.46,0a4.88,4.88,0,0,0,2.59-5.39c2.64-.1,4.29-.18,4.29-.18s6.07-2.78,0-10.33l-.32.25-1.3-3.82v-5.17s7.69-37,5.26-41.32-3.64-26.62-3.64-26.62l.81-24.24c2.19-4.53,3.32-11.62,3.89-17.17a36.58,36.58,0,0,0,1.55-8.15c.09-1.3.17-2.67.22-4.09a27.45,27.45,0,0,0-1.47-9.15,90.44,90.44,0,0,1,9.16-11.51,11.79,11.79,0,0,0,3.64-10.33l-2-13.51-4.86-23c.61-6.4-.72-10.08-2.2-12.16.35-2.06.68-4.13.93-6.2a79.35,79.35,0,0,0-1.42-27c-.7-3.09-1.66-6.26-3.82-8.6-2.46-2.65-6.44-4.27-7.35-7.74a25.21,25.21,0,0,0-.56-2.61c-.89-2.28-3.7-3.1-6.16-3.4-4.38-.53-10.71-.94-14.92.78-2.93,1.21-7,4.51-8.59,8.06a6.91,6.91,0,0,0-1,5,6.56,6.56,0,0,0,.7,1.69,15.22,15.22,0,0,0-1,5.33,15.51,15.51,0,0,0,9.9,14.38c.09.3.18.6.26.9a15,15,0,0,1,.39,2.16c-.07,1.41-.16,2.82-.23,4.22a4.74,4.74,0,0,1-.15.57,103.79,103.79,0,0,0-10.17,5.19c2.43,3.57-.4,18.67-.4,18.67-6.07,3.58-12.14,12.72-5.67,22.25S239.08,523,239.08,523l-1,15.54h0v0l-.2,3.1.08,0-.08,1.18.17,0v1.27c-2.85,1-7,3.14-9.47,7a25.08,25.08,0,0,1-4.24,5.2A3.12,3.12,0,0,0,224.83,561.47Zm48.85-41.28a14.75,14.75,0,0,1,1.44-7.81c.95,0,1.91,0,2.86,0,.1.67.21,1.31.35,1.89C279.15,517.81,275.87,519.48,273.68,520.19Z",
    transform: "translate(-61.06 -71.37)",
    fill: "url(#3a04da5e-6bbd-4e40-9ddd-c72d719fea9d)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M274.48,674.2l1.56,4.67L271,683.93l-16.74,3.89-12.07-1.17.78-4.28h0a5.15,5.15,0,0,1,3.83-3.77c5-1.17,14.42-3.82,16.41-7.52Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#db8b8b"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M274.48,674.2l1.56,4.67L271,683.93l-16.74,3.89-12.07-1.17.78-4.28h0a5.15,5.15,0,0,1,3.83-3.77c5-1.17,14.42-3.82,16.41-7.52Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M246.06,685.49l2.34-3.12-2.34-3.6s-7,2.82-10.12,2.43-4.67,5.07,1.17,6.62,38.93,0,38.93,0,5.84-2.72,0-10.12L271,681.59s-8.57,4.68-12.85,3.9Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#2e3037"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M235.55,692.11l12.07,1.16,16.74-3.89,5.06-5.06-.41-1.24-.58-1.74-.56-1.69-11.29-3.12a7,7,0,0,1-2.29,2.3c-3.67,2.5-10.26,4.31-14.12,5.22l-.49.14a5.17,5.17,0,0,0-2,1.21,5.12,5.12,0,0,0-1.39,2.42Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#db8b8b"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M235.55,692.11l12.07,1.16,16.74-3.89,5.06-5.06-.41-1.24-4.65,3.57s-8.56,4.68-12.85,3.9H239.45l2.33-3.12-2.1-3.24a5.17,5.17,0,0,0-2,1.21,5.12,5.12,0,0,0-1.39,2.42Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M239.45,690.94l2.33-3.12-2.33-3.6s-7,2.82-10.13,2.43-4.67,5.07,1.17,6.62,38.93,0,38.93,0,5.84-2.72,0-10.12L264.36,687s-8.56,4.68-12.85,3.9Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#2e3037"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M249.18,465.14s18.69,1.94,16-5.84a14.15,14.15,0,0,1-.58-6.88,19.11,19.11,0,0,1,3.31-7.92l-17.52,2.73a22.1,22.1,0,0,1,2.37,5.62C254.81,461.11,249.18,465.14,249.18,465.14Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#db8b8b"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M281.1,553.9s-.39,16.74-4.28,24.92L276,602.56s1.17,21.8,3.5,26.09-5.06,40.49-5.06,40.49v6.22s-12.45,4.68-16-.77L262,628.26,260.47,564Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#474463"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M281.1,553.9s-.39,16.74-4.28,24.92L276,602.56s1.17,21.8,3.5,26.09-5.06,40.49-5.06,40.49v6.22s-12.45,4.68-16-.77L262,628.26,260.47,564Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M288.89,500.17l2.33,6.23,1.95,13.24a11.7,11.7,0,0,1-3.5,10.12c-4.67,4.67-10.9,14.41-10.9,14.41L271.37,522s7.4-1.17,6.23-6.23-.78-14.41-.78-14.41Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#fc6681"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M288.89,500.17l2.33,6.23,1.95,13.24a11.7,11.7,0,0,1-3.5,10.12c-4.67,4.67-10.9,14.41-10.9,14.41L271.37,522s7.4-1.17,6.23-6.23-.78-14.41-.78-14.41Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.05
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M254.29,678.83c5,7.86,12.76,3.4,14.14,2.51l-.56-1.69-11.29-3.12A7,7,0,0,1,254.29,678.83Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M238.67,569.08c.39,5.45,7,25.31,7,25.31l4.67,16.34a129.57,129.57,0,0,1,5.13,35.54A35,35,0,0,0,257,657.46c3.12,8.56-3.11,20.24-3.11,20.24,5.45,9.73,14.79,3.12,14.79,3.12v-6.23s7.4-33.87,5.45-40.49-2.72-24.53-2.72-24.53V577.26A36.72,36.72,0,0,0,282.05,554c.1-1.27.17-2.61.22-4,.32-8.79-5.69-19.08-8-22.76-.56-.88-.91-1.38-.91-1.38L238.94,539.5l-.08,0v1.33l0,2.95Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#474463"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M250.35,447.23a22.1,22.1,0,0,1,2.37,5.62,15.15,15.15,0,0,0,11.84-.43,19.11,19.11,0,0,1,3.31-7.92Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.07,
    cy: 366.52,
    r: 15.18,
    fill: "#db8b8b"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M238.67,543.78l.16,0c16.33,3.35,36.82-13.66,36.82-13.66a20.87,20.87,0,0,1-1.42-2.9c-.56-.88-.91-1.38-.91-1.38L238.94,539.5l-.09,1.36Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M243,464.75s21.8-13.24,28.81-7.79l9.73,12.46s6.23,1.94,5.06,14.4l4.67,22.58-14,3.51S269,517.69,275.65,529c0,0-20.63,17.13-37,13.63l1.16-18.3s3.51-10.12-2.72-19.46-.39-18.3,5.45-21.81C242.56,483,245.29,468.25,243,464.75Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#fc6681"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M241.78,544.17s-8.17,1.55-12.07,7.78a24.05,24.05,0,0,1-4.07,5.09,3.09,3.09,0,0,0,.48,4.93c3.09,1.85,8.13,3,14.49-2.23C251.51,550.78,241.78,544.17,241.78,544.17Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#db8b8b"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M253.85,472.14s7.79-.78,9.73,19.47,5.06,24.92,5.06,24.92,1.95,10.51-2.72,16.74-13.63,19.46-13.63,19.46-9.73,2.73-11.68-7l12.07-22.58s1.95-7.78-2.72-13.23S241.78,468.25,253.85,472.14Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M253.07,471s7.79-.78,9.73,19.46,5.07,24.92,5.07,24.92,1.94,10.51-2.73,16.74-13.63,19.46-13.63,19.46-9.73,2.73-11.68-7L251.9,522s1.95-7.79-2.72-13.24S241,467.08,253.07,471Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#fc6681"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M246.65,485.57s-.78,12.07,2.72,18.69,3.51,15.18,0,19.86",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M244.7,470.78s3.12-3.11,12.07-3.5,12.85-3.12,12.85-3.12",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M266.36,418.26c2.36.29,5.07,1.1,5.92,3.33a24.77,24.77,0,0,1,.54,2.56c.88,3.4,4.71,5,7.07,7.59,2.09,2.29,3,5.4,3.68,8.42a79.19,79.19,0,0,1,1.37,26.45c-.76,6.46-2.31,12.82-2.75,19.3s.36,13.31,3.91,18.76c1.52,2.34,3.53,4.4,4.61,7-2.23,1.81-5.31,2.07-8.18,2.17q-5,.16-10,0a10.7,10.7,0,0,1-5.11-1.06,7.81,7.81,0,0,1-2.68-2.88c-1.91-3.25-2.4-7.15-2.32-10.93s.68-7.52.75-11.29c0-2.06-.12-4.24-1.3-5.92a19.19,19.19,0,0,0-3.27-3c-4.16-3.69-5.59-9.62-5.73-15.18s.77-11.14.3-16.69c-.18-2.17-1-4.78-3.13-5.2a13.57,13.57,0,0,1-2-.26c-1.72-.66-1.55-3.08-2-4.85-.55-2-2.24-3.52-2.72-5.53-1.12-4.71,4.87-10.33,8.8-12S262.14,417.74,266.36,418.26Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M266.75,417.48c2.36.3,5.06,1.11,5.92,3.33a24.41,24.41,0,0,1,.54,2.57c.88,3.4,4.71,5,7.07,7.58,2.09,2.29,3,5.4,3.68,8.42a79.19,79.19,0,0,1,1.37,26.45c-.76,6.46-2.31,12.82-2.75,19.3s.36,13.31,3.91,18.76c1.52,2.34,3.53,4.4,4.61,7-2.23,1.81-5.31,2.07-8.18,2.17q-5,.16-10.05,0a10.7,10.7,0,0,1-5.11-1.06,7.86,7.86,0,0,1-2.68-2.87c-1.92-3.26-2.4-7.16-2.32-10.94s.68-7.52.75-11.29c0-2.05-.12-4.24-1.3-5.92a19.6,19.6,0,0,0-3.27-3c-4.16-3.69-5.6-9.61-5.74-15.18s.78-11.14.31-16.69c-.18-2.17-1-4.78-3.13-5.2a13.57,13.57,0,0,1-2-.26c-1.72-.66-1.55-3.08-2-4.85-.55-2-2.24-3.52-2.72-5.53-1.12-4.7,4.87-10.33,8.8-12S262.53,417,266.75,417.48Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#472727"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 961.14,
    cy: 692.67,
    rx: 24,
    ry: 3.3,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 869.2,
    cy: 702,
    rx: 24,
    ry: 3.3,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 760.91,
    cy: 689.38,
    rx: 24,
    ry: 3.3,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 906,
    cy: 728.54,
    rx: 17.06,
    ry: 2.34,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 810.58,
    cy: 726.19,
    rx: 17.06,
    ry: 2.34,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M929.75,772.62s33.66-110.34-5.27-154.54c-29.12-33.06-62.17-29.11-77-25a27.37,27.37,0,0,0-17.66,14.68c-5.17,11.16-4.24,29.29,32.3,50.44,61.17,35.41,65,84,65,84Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M852.77,608.71s99.23,31,77,163.91",
    transform: "translate(-61.06 -71.37)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M910.73,619.84s-13.67,9.2-9.32,23",
    transform: "translate(-61.06 -71.37)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M862.72,628s8.36-8.5,18.52-3.81",
    transform: "translate(-61.06 -71.37)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M902,670.76s14.66-7.44,18.45,1.88",
    transform: "translate(-61.06 -71.37)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M938.24,686.28s-11-.88-11.21,4.39",
    transform: "translate(-61.06 -71.37)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M931.11,773.5s-39.42-80.2-50.25-78.44c-5.14.83-7.51,5.89-8.59,11a32.27,32.27,0,0,0,2.15,19.52C880,738.39,895,762.76,931.11,773.5Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M881.15,710.28s41.38,60,49.38,62.64",
    transform: "translate(-61.06 -71.37)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 816.28,
    y1: 648.28,
    x2: 825.94,
    y2: 648.28,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 827.85,
    y1: 670.23,
    x2: 842.99,
    y2: 670.88,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 837.06,
    y1: 652.67,
    x2: 835.42,
    y2: 660.56,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 853.16,
    y1: 676.67,
    x2: 852.87,
    y2: 683.84,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M929.94,773.5s39.42-80.2,50.25-78.44c5.15.83,7.52,5.89,8.59,11a32.27,32.27,0,0,1-2.15,19.52C981,738.39,966,762.76,929.94,773.5Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M979.9,710.28s-41.38,60-49.37,62.64",
    transform: "translate(-61.06 -71.37)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 922.64,
    y1: 648.28,
    x2: 912.98,
    y2: 648.28,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 911.07,
    y1: 670.23,
    x2: 895.93,
    y2: 670.88,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 901.86,
    y1: 652.67,
    x2: 903.5,
    y2: 660.56,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 885.76,
    y1: 676.67,
    x2: 886.05,
    y2: 683.84,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M862.25,792.23a6.81,6.81,0,0,1-2.24-3.39,3,3,0,0,1,1.57-3.45c1.44-.55,3,.45,4.14,1.46s2.5,2.16,4,1.95a6.17,6.17,0,0,1-1.9-5.75,2.42,2.42,0,0,1,.53-1.16c.8-.86,2.25-.49,3.21.18,3,2.14,3.89,6.28,3.91,10a18.89,18.89,0,0,0,0-4.12,4.23,4.23,0,0,1,1.55-3.64,4.65,4.65,0,0,1,2.36-.56,4.9,4.9,0,0,1,3.83,1.09c1.16,1.24.86,3.33-.15,4.7a14.65,14.65,0,0,1-4,3.17,8.9,8.9,0,0,0-2.83,2.7,3.48,3.48,0,0,0-.21.48h-8.57A23.68,23.68,0,0,1,862.25,792.23Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.47,759.93a6.81,6.81,0,0,1-2.24-3.39,3,3,0,0,1,1.56-3.44c1.44-.56,3,.44,4.15,1.45s2.5,2.16,4,2a6.17,6.17,0,0,1-1.9-5.75,2.42,2.42,0,0,1,.53-1.16c.8-.86,2.25-.49,3.21.18,3,2.14,3.89,6.28,3.91,10a18.89,18.89,0,0,0,0-4.12,4.23,4.23,0,0,1,1.55-3.64,4.65,4.65,0,0,1,2.36-.56,4.86,4.86,0,0,1,3.82,1.09c1.17,1.24.86,3.33-.15,4.7a14.6,14.6,0,0,1-4,3.17,8.9,8.9,0,0,0-2.83,2.7,3.48,3.48,0,0,0-.21.48h-8.57A23.68,23.68,0,0,1,1012.47,759.93Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M962.41,792.23a6.83,6.83,0,0,1-2.25-3.39,3,3,0,0,1,1.57-3.45c1.44-.55,3,.45,4.15,1.46s2.5,2.16,4,1.95a6.13,6.13,0,0,1-1.9-5.75,2.33,2.33,0,0,1,.53-1.16c.8-.86,2.24-.49,3.2.18,3,2.14,3.9,6.28,3.91,10a18.89,18.89,0,0,0,.06-4.12,4.22,4.22,0,0,1,1.54-3.64,4.68,4.68,0,0,1,2.36-.56,4.89,4.89,0,0,1,3.83,1.09c1.16,1.24.86,3.33-.15,4.7a14.75,14.75,0,0,1-4,3.17,8.7,8.7,0,0,0-2.83,2.7,2.58,2.58,0,0,0-.21.48h-8.58A23.62,23.62,0,0,1,962.41,792.23Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M820.42,726.94s-3.22,4.2,1.48,10.55,8.58,11.71,7,15.67c0,0-7.09-11.79-12.86-12S814.07,734,820.42,726.94Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M820.42,726.94a5,5,0,0,0-.66,1.32c-5.63,6.61-8.63,12.79-3.22,12.94,5.05.15,11.1,9.17,12.54,11.44a3.16,3.16,0,0,1-.17.52s-7.09-11.79-12.86-12S814.07,734,820.42,726.94Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M814.44,732.3c0,1.48.17,2.68.37,2.68s.37-1.2.37-2.68-.2-.78-.41-.78S814.44,730.82,814.44,732.3Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd037"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M812.39,734.07c1.3.7,2.43,1.13,2.53.95s-.87-.9-2.17-1.61-.79-.19-.89,0S811.09,733.36,812.39,734.07Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd037"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M837.41,726.94s3.21,4.2-1.49,10.55-8.57,11.71-7,15.67c0,0,7.09-11.79,12.87-12S843.76,734,837.41,726.94Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#6c63ff"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M837.41,726.94a5.16,5.16,0,0,1,.65,1.32c5.64,6.61,8.64,12.79,3.22,12.94-5,.15-11.09,9.17-12.54,11.44,0,.18.11.35.17.52,0,0,7.09-11.79,12.87-12S843.76,734,837.41,726.94Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.1
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M843.38,732.3c0,1.48-.16,2.68-.37,2.68s-.37-1.2-.37-2.68.21-.78.41-.78S843.38,730.82,843.38,732.3Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd037"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M845.44,734.07c-1.3.7-2.44,1.13-2.53.95s.87-.9,2.17-1.61.79-.19.89,0S846.74,733.36,845.44,734.07Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#ffd037"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M842.36,752.61s-9-.28-11.7-2.21-13.83-4.23-14.5-1.13-13.52,15.39-3.36,15.47,23.58-1.58,26.29-3.23S842.36,752.61,842.36,752.61Z",
    transform: "translate(-61.06 -71.37)",
    fill: "#a8a8a8"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M812.61,763.66c10.16.08,23.59-1.58,26.3-3.23,2.05-1.25,2.88-5.75,3.15-7.83h.3s-.57,7.25-3.27,8.9-16.14,3.31-26.29,3.23c-2.93,0-3.95-1.07-3.89-2.61C809.32,763.06,810.43,763.64,812.61,763.66Z",
    transform: "translate(-61.06 -71.37)",
    opacity: 0.2
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.29,
    cy: 706.09,
    rx: 34.72,
    ry: 5.13,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.36,
    cy: 752.14,
    rx: 34.72,
    ry: 5.13,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 622.26,
    cy: 632.15,
    rx: 22.99,
    ry: 2.57,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 514.79,
    cy: 706.09,
    rx: 22.99,
    ry: 2.57,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 466.34,
    cy: 752.14,
    rx: 22.99,
    ry: 2.57,
    fill: "#6c63ff",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluWorkflow);
export default __webpack_public_path__ + "static/media/illu-workflow.7c14e24f18e1793bd6268961b08b8f25.svg";
export { ForwardRef as ReactComponent };